import { useContext } from 'react';
import {
  TimelineSizeContext,
  type TimelineSizeState,
} from '../timeline-size-provider';

export const useTimelineSize = (): TimelineSizeState => {
  const state = useContext(TimelineSizeContext);

  if (!state) {
    throw new Error(
      'useTimelineSize must be used within a TimelineSizeProvider',
    );
  }

  return state;
};
